<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-level-track-reward-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>


import VueTypes from "vue-types";

import RLevelTrackRewardTable from "@/modules/redactor/views/level-track/reward/r-level-track-reward-table.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

import { LevelTrackReward } from "@/modules/redactor/models/level-track/LevelTrackReward";

export default {
  name: "r-level-track-reward-panel",
  components: {RPanel, RLevelTrackRewardTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Available Rewards"),
    items: VueTypes.arrayOf(LevelTrackReward),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
